import React, { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import dayjs from 'dayjs';
import LargeModal from 'components/form/LargeModal';
import SubmitButton from 'components/button/SubmitButton';
import GrayBox from 'components/container/GrayBox';
import VerticalTable from 'components/table/VerticalTable';
import DefaultSelect from 'components/select/DefaultSelect';
import { osOptions, promotionTypeList, PublicState } from 'utils/constant';
import DefaultRadio from 'components/input/DefaultRadio';
import {
  fetchPromotionDropApis,
  promotionApis,
} from 'apis/operation/promotionApi';
import LocalizingContext from 'context/LocalizingContext';
import LocalizingInputPromotion from './LocalizingInputPromotion';
import DefaultInput from 'components/input/DefaultInput';
import RangeDatePicker from 'components/input/RangeDatePicker';
import { oldNoticeApi } from 'apis/operation/oldNoticeApis';
import { message } from 'antd';
import { cashingApis } from 'apis/common/cashingApis';
import { fetchProjectList } from 'apis/common/commonApis';
import useExceptionCultureDropQuery from 'hooks/queries/common/useExceptionCultureDropQuery';
import { useTranslation } from 'react-i18next';

/**
 *
 * @returns {운영 - 프로모션 인풋 모달 (등록 & 수정)}
 */
const PromotionInputModal = ({ visible, setVisible, record, fetchData }) => {
  const { t } = useTranslation();
  const publicState = PublicState();
  const [cookies] = useCookies();
  const langList = useContext(LocalizingContext);
  const dateFormat = 'YYYY-MM-DD HH:mm:00';
  const [bannerDropList, setBannerDropList] = useState();
  const [projectDropList, setProjectDropList] = useState();
  const [pageDropList, setPageDropList] = useState();
  const [noticeDropList, setNoticeDropList] = useState();

  const { data: exceptionCultureDropList } = useExceptionCultureDropQuery();

  const today = dayjs().format(dateFormat);

  const [detailData, setDetailData] = useState({
    promotion_no: 0,
    title: '',
    is_public: 0,
    start_date: today,
    end_date: today,
    promotion_type: 'none',
    location: '',
    exception_country: '',
  });
  const [langData, setLangData] = useState([
    { lang: 'KO', design_id: -1, id: 0 },
  ]);

  /// 다국어 폼 데이터 세팅 메서드
  const setLangListUpdate = (valArray) => {
    let newArr = [];
    langList?.map((v, i) =>
      newArr.push({
        design_id: -1,
        image_key: '',
        image_url: '',
        lang: v.code,
        code_name: v.code_name,
        key: i,
      }),
    );
    // 기존 랭데이터 입력 값이 있을 경우
    if (valArray) {
      for (let i = 0; i < newArr.length; i++) {
        for (let j = 0; j < valArray?.length; j++) {
          if (newArr[i].lang.indexOf(valArray[j].lang) !== -1) {
            // Object.assign(target, ...sources)
            // 파라미터로 받은 소스 객체 속성을 target 객체로 복사한다.
            Object.assign(newArr[i], valArray[j]);
          }
        }
      }
    }
    setLangData(newArr);
  };

  /// 멀티 드롭다운 이벤트
  const handleMultiChange = async (val, data) => {
    if (val.length <= 0) {
      setDetailData({ ...detailData, exception_culture: null });
    } else {
      setDetailData({ ...detailData, [data[0].name]: val.toString() });
    }
  };

  const handleDateChange = (date, dateString) => {
    if (!date) {
      setDetailData({
        ...detailData,
        start_date: today,
        end_date: today,
      });
      return;
    }
    setDetailData({
      ...detailData,
      start_date: `${dateString[0]}`,
      end_date: `${dateString[1]}`,
    });
  };

  /// input & radio event
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetailData({ ...detailData, [name]: value });
  };
  /// select event
  const handleSelectChange = (val, op) => {
    setDetailData({ ...detailData, [op.name]: val });
  };
  /// modal close
  const handleClose = () => {
    setVisible(false);
    setDetailData({
      promotion_no: 0,
      title: '',
      is_public: 0,
      start_date: today,
      end_date: today,
      promotion_type: 'none',
      location: '',
      exception_country: '',
    });
  };

  const handleSubmit = async () => {
    if (detailData.title === '') {
      alert(t('promotion.promotionInputModal.titleMessage'));
      return false;
    }
    if (detailData.end_date === '' || detailData.start_date === '') {
      alert(t('promotion.promotionInputModal.dateMessage'));
      return false;
    }
    // console.log(detailData);
    const res = await promotionApis.update(detailData, langData);
    if (!res) {
      return false;
    }
    // 캐싱 비우기
    await cashingApis.notice_promotion_cash();
    fetchData();
    setVisible(false);
    message.success(t('promotion.promotionInputModal.submitSuccessMessage'), 1);
  };

  const fetchDetailData = async (promotionNo) => {
    const res = await promotionApis.detail(promotionNo);

    setDetailData({ ...res?.detail[0], promotion_no: promotionNo });
    setLangListUpdate(res?.langList);
  };

  const fetchDropdownData = async () => {
    const resBannerList = await fetchPromotionDropApis.promotion_banner_list();
    const resLocationList = await fetchPromotionDropApis.promotion_location();
    const resProjectList = await fetchProjectList();
    const resNoticeList = await oldNoticeApi.read();

    let newData = [];
    resNoticeList?.map((v, i) =>
      newData.push({ key: i, value: String(v.notice_no), text: v.notice_name }),
    );

    setBannerDropList(resBannerList);
    setPageDropList(resLocationList);
    setProjectDropList(resProjectList);
    setNoticeDropList(newData);
  };

  useEffect(() => {
    if (record) {
      fetchDetailData(record.promotion_no);
    } else {
      setLangListUpdate();
    }
    fetchDropdownData().catch(console.log);
  }, [visible]);

  return (
    <LargeModal
      title={`${t('promotion.promotionInputModal.title')} ${
        record
          ? t('promotion.promotionInputModal.correction')
          : t('promotion.promotionInputModal.registration')
      }`}
      visible={visible}
      onCancel={handleClose}
    >
      <div className='input_wrap'>
        <GrayBox left>
          <LocalizingInputPromotion
            langData={langData}
            setLangData={setLangData}
            bannerDropList={bannerDropList}
          />
        </GrayBox>
        <GrayBox style={{ height: '39rem' }}>
          <VerticalTable>
            <>
              <tr>
                <th style={{ width: '7.5rem' }}>
                  {t('promotion.promotionInputModal.imageName')}
                </th>
                <td>
                  <DefaultInput
                    name='title'
                    value={detailData?.title}
                    onChange={handleInputChange}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('promotion.promotionInputModal.postingPeriod')}</th>
                <td>
                  <RangeDatePicker
                    style={{ width: '100%' }}
                    minuteStep={10}
                    format={dateFormat}
                    showTime={true}
                    value={[
                      dayjs(detailData?.start_date, dateFormat),
                      dayjs(detailData?.end_date, dateFormat),
                    ]}
                    ranges={{
                      오늘: [dayjs(), dayjs()],
                      이번주: [dayjs().startOf(today), dayjs().endOf('week')],
                      이번달: [dayjs().startOf(today), dayjs().endOf('month')],
                    }}
                    onChange={handleDateChange}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('promotion.promotionInputModal.path')}</th>
                <td className='promotion_type_td'>
                  <div>
                    <p>{t('promotion.promotionInputModal.promotionType')}</p>
                    <DefaultSelect
                      name='promotion_type'
                      value={detailData?.promotion_type}
                      optionList={promotionTypeList}
                      onChange={handleSelectChange}
                    />
                  </div>
                  <div>
                    <p>{t('promotion.promotionInputModal.destination')}</p>

                    <DefaultSelect
                      name='location'
                      value={detailData?.location}
                      onChange={handleSelectChange}
                      optionList={
                        detailData?.promotion_type === 'project'
                          ? projectDropList
                          : detailData?.promotion_type === 'page'
                          ? pageDropList
                          : detailData?.promotion_type === 'notice'
                          ? noticeDropList
                          : [
                              {
                                key: 0,
                                value: '-1',
                                text: t(
                                  'promotion.promotionInputModal.locationSelect.none',
                                ),
                              },
                            ]
                      }
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th>{t('promotion.promotionInputModal.displayPlatform')}</th>
                <td>
                  <DefaultSelect
                    name='os'
                    value={detailData?.os}
                    optionList={osOptions}
                    onChange={handleSelectChange}
                  />
                </td>
              </tr>
              <tr>
                <th>{t('promotion.promotionInputModal.publicStatus')}</th>
                <td>
                  <DefaultRadio
                    name='is_public'
                    optionList={publicState}
                    onChange={handleInputChange}
                    defaultValue={detailData?.is_public}
                    value={detailData?.is_public}
                  />
                </td>
              </tr>
              <tr>
                <th>
                  {t('promotion.promotionInputModal.excludedCulturalRegions')}
                </th>
                <td>
                  <DefaultSelect
                    // title="제외 문화권"
                    name='exception_culture'
                    mode='multiple'
                    optionList={exceptionCultureDropList}
                    value={detailData?.exception_culture
                      ?.split(',')
                      ?.map((v) => {
                        return v;
                      })}
                    onChange={handleMultiChange}
                  />
                </td>
              </tr>
            </>
          </VerticalTable>
        </GrayBox>
      </div>
      <div className='button_wrap'>
        <SubmitButton onClick={handleSubmit}>
          {t('promotion.promotionInputModal.register')}
        </SubmitButton>
      </div>
    </LargeModal>
  );
};

export default PromotionInputModal;
